'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../../node_modules/@radix-ui/react-dropdown-menu/dist/index.cjs');
var Typography_web = require('../../../atoms/Typography/Typography.web.cjs');
var reactFontawesome = require('../../../../react-fontawesome/react-fontawesome.cjs');
var Item_web_styles = require('./Item.web.styles.cjs');

/**
 * Subcomponent of Dropdown. Is a selectable item within a DropdownMenu.
 *
 * @scope: Web
 */ const Item = ({ type = "default", icon, children, ...rest })=>{
    const itemStyles = [
        Item_web_styles.item,
        type === "danger" && Item_web_styles.variants.danger
    ];
    const renderIcon = ()=>{
        if (icon) {
            return /*#__PURE__*/ jsxRuntime.jsx("div", {
                css: Item_web_styles.iconContainer,
                children: /*#__PURE__*/ jsxRuntime.jsx(reactFontawesome.FontAwesomeIcon, {
                    icon: icon
                })
            });
        }
        return /*#__PURE__*/ jsxRuntime.jsx("div", {
            css: Item_web_styles.iconContainer
        });
    };
    if (type === "sectionHeading") {
        return /*#__PURE__*/ jsxRuntime.jsx(jsxRuntime.Fragment, {
            children: /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                styleOverride: "h5",
                isMarginless: true,
                customCss: Item_web_styles.text.sectionHeading,
                children: children
            })
        });
    }
    return /*#__PURE__*/ jsxRuntime.jsxs(index.Item, {
        css: itemStyles,
        ...rest,
        children: [
            renderIcon(),
            /*#__PURE__*/ jsxRuntime.jsx("div", {
                css: Item_web_styles.text.base,
                children: children
            })
        ]
    });
};
Item.displayName = "DropdownMenu.Item";

exports.Item = Item;
//# sourceMappingURL=Item.web.cjs.map
